export const customMedium = 800;